import React from 'react';
import './About.css';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';

const About = () => {
  return (
    <>
      <CustomHeader activePage="about" />

      {/* Hero Section */}
      <section className="about-hero">
        <h1>About IntelUniVen</h1>
        <p>We are passionate innovators dedicated to transforming ideas into scalable digital solutions that drive success and create meaningful impact in the digital world.</p>
      </section>

      {/* Main Content */}
      <div className="about-content">
        {/* Company Story */}
        <section className="section">
          <h2>Our Story</h2>
          <p>Founded with a vision to bridge the gap between innovative technology and practical business solutions, IntelUniVen Software Solution Pvt Ltd has emerged as a trusted partner for businesses seeking digital transformation. Our journey began with a simple belief: that every great idea deserves exceptional execution.</p>
          <p>Since our inception, we have been committed to delivering cutting-edge software solutions that not only meet current business needs but also anticipate future challenges. We combine technical expertise with creative thinking to build products that truly make a difference.</p>
        </section>

        {/* Mission & Vision */}
        <div className="mission-vision">
          <div className="mission-card">
            <i className="fas fa-bullseye"></i>
            <h3>Our Mission</h3>
            <p>To empower businesses with innovative, scalable, and reliable software solutions that drive growth, enhance efficiency, and create sustainable competitive advantages in the digital marketplace.</p>
          </div>
          <div className="vision-card">
            <i className="fas fa-eye"></i>
            <h3>Our Vision</h3>
            <p>To be the leading software development partner that transforms industries through intelligent technology solutions, fostering innovation and digital excellence worldwide.</p>
          </div>
        </div>

        {/* Core Values */}
        <section className="section">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <i className="fas fa-lightbulb"></i>
              <h4>Innovation</h4>
              <p>We embrace cutting-edge technologies and creative thinking to deliver breakthrough solutions.</p>
            </div>
            <div className="value-item">
              <i className="fas fa-shield-alt"></i>
              <h4>Quality</h4>
              <p>We maintain the highest standards in everything we do, ensuring excellence in every project.</p>
            </div>
            <div className="value-item">
              <i className="fas fa-handshake"></i>
              <h4>Partnership</h4>
              <p>We build lasting relationships with our clients, working together towards shared success.</p>
            </div>
            <div className="value-item">
              <i className="fas fa-rocket"></i>
              <h4>Agility</h4>
              <p>We adapt quickly to changing needs and market dynamics, delivering solutions that evolve with you.</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="section stats-section">
          <h2>Our Impact in Numbers</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">3+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="section">
          <h2>Meet Our Team</h2>
          <p>Our diverse team of talented professionals brings together expertise in software development, design, project management, and business strategy to deliver exceptional results.</p>
          <div className="team-grid">
            <div className="team-card">
              <div className="team-avatar">
                <img src="/ceo.jpeg" alt="Sachin Narandekar" onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }} />
                <div className="initials">SN</div>
              </div>
              <h4>Sachin Narandekar</h4>
              <div className="role">CEO & Founder</div>
              <p>over 20+ years of IT industry experience, excelling in strategic planning, team leadership, client relations, and mentoring. His technical expertise spans software testing, Oracle and SAP ERP, application design, business analysis, and agile methodologies like SCRUM.

He has trained over 100,000 individuals with impactful results. Beyond tech, Sachin is a certified Reiki Master, Sujok therapist, NLP coach, and clinical/spiritual hypnotherapist, integrating holistic practices and meditation into his life and work.</p>
            </div>
            <div className="team-card">
              <div className="team-avatar">
                <img src="/chro.jpg" alt="Devangana Mandal" onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }} />
                <div className="initials">DM</div>
              </div>
              <h4>Devangana Mandal</h4>
              <div className="role">CHRO</div>
              <p>dynamic leader with 10+ years of IT experience and 5+ years in academia, giving her deep insight into both industry and freshers. A Quora Top Writer (2018), she's a passionate writer, animal welfare advocate, and is fondly known at IntelUniVen as the "Fearless Bengal Tigress."</p>
            </div>
            <div className="team-card">
              <div className="team-avatar">
                <img src="/clo.jpeg" alt="Dalia Chakraborty" onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }} />
                <div className="initials">DC</div>
              </div>
              <h4>Dalia Chakraborty</h4>
              <div className="role">Chief Learning Officer</div>
              <p>Dalia Chakraborty holds a Bachelor’s Degree in Computer Science from Visvesvaraya Technological University and has over 10 years of experience in the IT industry. Throughout her career, she has taken on roles such as Technical Trainer, QA Engineer, Scrum Master, and Product Owner, working with leading product-based multinational companies. Her extensive knowledge of the IT industry, paired with her passion for teaching, enables her to effectively share her expertise and guide others in the field.

She has also completed a Post Graduate Diploma in Counseling and Psychotherapy, driven by a deep desire to better understand herself and the people around her. 

Outside of her professional life, Dalia is a Taekwondo black belt and represented India at the international level, winning a gold medal in 2017. In her free time, she enjoys sketching, painting and writing allowing her creativity to flourish.</p>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="section">
          <h2>Why Choose IntelUniVen?</h2>
          <p>We understand that choosing the right technology partner is crucial for your business success. Here's what sets us apart:</p>
          <ul style={{marginTop: '1.5rem', paddingLeft: '2rem', color: 'var(--text-light)', lineHeight: '1.8'}}>
            <li><strong>Proven Expertise:</strong> Our team has successfully delivered projects across various industries and technologies.</li>
            <li><strong>Custom Solutions:</strong> We don't believe in one-size-fits-all. Every solution is tailored to your specific needs.</li>
            <li><strong>Agile Methodology:</strong> We use modern development practices to ensure timely delivery and quality outcomes.</li>
            <li><strong>Ongoing Support:</strong> Our relationship doesn't end at deployment. We provide continuous support and maintenance.</li>
            <li><strong>Competitive Pricing:</strong> We offer high-quality solutions at competitive rates without compromising on quality.</li>
          </ul>
        </section>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
        <button
          onClick={() => window.location.href = '/meet-our-developer'}
          className="btn-primary"
          style={{ fontSize: '1.2rem', padding: '0.75rem 2rem', borderRadius: '8px', cursor: 'pointer' }}
        >
          Meet Our Developer
        </button>
      </div>

      <CustomFooter />
    </>
  );
};

export default About;